import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import styles from './label.css';

const Label = ({ htmlFor, text, required, className, children }) => (
  <label
    className={styles.labelWrapper}
    htmlFor={htmlFor}
  >
    <span className={classNames(styles.label, className)}>
      {text}
      {required && <span className={styles.required}>required</span>}
    </span>
    {children}
  </label>
);

Label.propTypes = {
  className: PropTypes.string,
  htmlFor: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object,
  ]).isRequired,
  required: PropTypes.bool,
  children: PropTypes.node,
};

Label.defaultProps = {
  className: '',
  required: false,
  children: null,
};

export default withStyles(styles)(Label);
